import React from 'react'

interface ArchivedWarningProps {
  message: string
}

const ArchivedWarning: React.FC<ArchivedWarningProps> = ({ message }) => {
  return (
    <div className="absolute bg-red text-on-solid p-4 rounded text-base left-[50%] z-[99] [--tw-translate-x:-50%]">
      {message}
    </div>
  )
}

export default ArchivedWarning
